export const original = "an-original2";



// WEBPACK FOOTER //
// ./src/mod7.js